.container {
  padding-top: 50px;
  padding-right: 20px;
}

.accountDropdown {
  position: absolute;
  top: 5px;
  right: 5px;
  
}
